<div class="mdv-image-gallery">
  @if (fileId !== null) {
    <ca-image-loader
    [image]="
    {id: fileId} | filedownloadurl | async
    "
      [showPlaceholder]="false"
      fit="contain"
      >
    </ca-image-loader>
  } @else {
    <div class="media-placeholder"></div>
  }
</div>
